import { TextFieldUI, TextFieldUIProps } from '../TextField/TextFieldUI';

export const NumberFieldUI = <Fields extends object>(
  props: TextFieldUIProps<Fields>
) => (
  <TextFieldUI<Fields>
    inputMode="numeric"
    spellCheck={false}
    maxLength={20}
    {...props}
  />
);
